// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__1CT01","logo":"styles_logo__329cm","slogan":"styles_slogan__2srmg","description":"styles_description__2xLtU"};